import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const createEmailCampaign = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/email-campaign/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getListEmailCampaignHistory = async (params = '') => {
  const options = prepareRequestOptions(
    `/admin/email-campaign/history/list${params}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewEmailCampaignHistoryById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/email-campaign/${id}/history/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getEmailCampaignRecipientsListData = async (id, params = '') => {
  const options = prepareRequestOptions(
    `/admin/email-campaign/${id}/recipients/list${params}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};
